export const isStale = function (car) {
  const connectionType = {
    wifi: 0,
    realtime: 1,
    none: 2
  };
  return (car.Connection === connectionType.none);
};